export interface FaqItem {
  q: string;
  a: string;
  group: string;
}

export const faqItems: FaqItem[] = [
  {
    group: "阅读与追更",
    q: "如何在汗汗漫画上追更悬疑推理漫画？",
    a: "进入首页后，在「最新更新」或对应分类(悬疑、推理、烧脑、反转、案件、解密)中查找作品，点击作品进入详情页即可查看最新章节。收藏作品后，更新时会第一时间在更新列表中标出。",
  },
  {
    group: "阅读与追更",
    q: "收藏的作品在哪里查看更新进度？",
    a: "作品详情页点击「收藏」按钮即可加入书架。之后可在站点顶部的「追更书架」入口查看已收藏作品的连载进度与最新章节提醒。",
  },
  {
    group: "分类与内容",
    q: "悬疑、推理、烧脑、反转这些分类有什么区别？",
    a: "悬疑偏重气氛与谜团的营造，推理强调逻辑推演与破案过程，烧脑多涉及高智商设定与复杂世界观，反转则主打出人意料的剧情翻转，案件聚焦刑侦凶案，解密偏重密码机关与隐藏真相。你可以按喜好快速定位。",
  },
  {
    group: "分类与内容",
    q: "哪些作品支持免费阅读全部章节？",
    a: "站内大部分悬疑推理作品均可免费追更。个别长篇连载会以「限免」或「完结合集」的形式呈现，具体以作品详情页的章节目录标识为准。",
  },
  {
    group: "账号与设备",
    q: "在手机上阅读体验如何？支持哪些设备？",
    a: "本站采用响应式设计，手机、平板、电脑均可流畅阅读。移动端自动适配翻页与章节目录，无需安装额外应用即可在线看。",
  },
  {
    group: "账号与设备",
    q: "阅读记录会丢失吗？",
    a: "同一台设备上的阅读进度会自动保存，下次打开可继续。跨设备同步需要登录账号后开启云端同步功能。",
  },
  {
    group: "更新与建议",
    q: "新作上线和更新频率如何？",
    a: "我们每周都会上新多部悬疑推理佳作，连载作品通常每周更新，并在更新列表置顶标记，方便你第一时间看到最新话。",
  },
  {
    group: "更新与建议",
    q: "如何推荐喜欢的悬疑推理漫画或反馈意见？",
    a: "你可以在「联系我们」页面留言推荐作品或提出建议，我们会认真阅读每一条反馈，并优先评估高人气推荐。",
  },
];